import React from 'react';
import styled from 'styled-components';
import { SPACING } from '@govuk-react/constants';
import {
    Main,
    GridRow,
    GridCol,
    LeadParagraph,
    Paragraph,
    ListNavigation,
    Header
} from 'govuk-react';
import { asAnchor } from '@govuk-react/hoc';

const AnchorTag = asAnchor('a');

const Introduction = styled.div({
    paddingTop: SPACING.SCALE_4,
    paddingBottom: SPACING.SCALE_2
});

const ContentItem = styled.div({
    paddingTop: SPACING.SCALE_4,
    paddingBottom: SPACING.SCALE_4
});

const PageContents = styled.div({
    paddingTop: SPACING.SCALE_4,
    paddingBottom: SPACING.SCALE_2
});

const ExampleOnePage = () => (
    <Main>
        <GridRow>
            <GridCol columnTwoThirds>
                <Introduction>
                    <Header level={1}>Layout 2</Header>
                    <LeadParagraph>
                        Praesent aliquam massa quis nisi imperdiet, id commodo sem porttitor. Proin nulla magna, pellentesque eu quam eget, maximus dignissim ligula.
                    </LeadParagraph>
                    <Paragraph>
                        Nulla tincidunt mauris metus, in dictum risus egestas eget. Mauris nec ipsum erat.
                    </Paragraph>
                </Introduction>
            </GridCol>
        </GridRow>
        <GridRow>
            <GridCol columnOneThird>
                <PageContents>
                    <Header level={4}>Secondary Column</Header>
                    <ListNavigation listStyleType="square">
                        <AnchorTag href="https://example.com/link-a">Link A</AnchorTag>
                        <AnchorTag href="https://example.com/link-b">Link B</AnchorTag>
                        <AnchorTag href="https://example.com/link-c">Link C</AnchorTag>
                    </ListNavigation>
                </PageContents>
            </GridCol>
            <GridCol columnTwoThirds>
                <ContentItem>
                    <Header level={2}>Content item</Header>
                    <Paragraph>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                        eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                        ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                        aliquip ex ea commodo consequat. Duis aute irure dolor in
                        reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                        pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                        culpa qui officia deserunt mollit anim id est laborum
                    </Paragraph>
                </ContentItem>
                <ContentItem>
                    <Header level={2}>Content item</Header>
                    <Paragraph>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                        eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                        ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                        aliquip ex ea commodo consequat. Duis aute irure dolor in
                        reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                        pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
                        culpa qui officia deserunt mollit anim id est laborum
                    </Paragraph>
                </ContentItem>
            </GridCol>
        </GridRow>
    </Main>
);

export default ExampleOnePage;
